var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.42148 7.00719C8.03096 6.61667 7.39779 6.61667 7.00727 7.00719C6.61675 7.39771 6.61675 8.03088 7.00727 8.4214L10.5859 12L7.00727 15.5786C6.61675 15.9691 6.61675 16.6023 7.00727 16.9928C7.39779 17.3834 8.03096 17.3834 8.42148 16.9928L12.0001 13.4142L15.5787 16.9928C15.9692 17.3834 16.6024 17.3834 16.9929 16.9928C17.3834 16.6023 17.3834 15.9691 16.9929 15.5786L13.4143 12L16.9929 8.4214C17.3834 8.03088 17.3834 7.39771 16.9929 7.00719C16.6024 6.61667 15.9692 6.61667 15.5787 7.00719L12.0001 10.5858L8.42148 7.00719Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.d9b7bb16ef8e0e6c421bb4f51387d858.svg";
export { ForwardRef as ReactComponent };